/**
 * Rich Text Editor - Unified exports
 */

// Main components
export { default as RichTextEditor } from './RichTextEditor.vue';
export { default as EditorToolbar } from './EditorToolbar.vue';

// Configuration
export {
  VARIANTS,
  TOOLBAR_BUTTONS,
  IMAGE_CONFIG,
  MARKDOWN_SHORTCUTS,
  getVariantConfig,
  getToolbarButton
} from './editorConfig';

// Composables
export { useMarkdownShortcuts, matchMarkdownPattern } from './useMarkdownShortcuts';
export {
  useMentions,
  extractMentionsFromEditor,
  extractMentionStrings,
  updateMentionUsers
} from './useMentions';
export {
  useEmbeds,
  detectProvider,
  generateEmbedData,
  EMBED_PROVIDERS
} from './useEmbeds';
export {
  useDrafts,
  clearAllDrafts,
  generateEditorId
} from './useDrafts';

// Default export
export { default } from './RichTextEditor.vue';
